import React, { useEffect, useRef, useState } from 'react';
import Navbar from '../Navbar';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import Menu_Items from '../Menu_Items';
import { MdEditSquare } from "react-icons/md";
import Cookies from 'js-cookie';
import { FaAngleDown } from "react-icons/fa";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import "../Calendar.css";


function Edit_Export_Details() {
  const { id, int_id, E_id } = useParams();
  const [su_admin, setsu_admin] = useState(false)
  const [admin, setadmin] = useState(false)
  const [nonetags, setnonetags] = useState([]);
  const [Out_bound, setOut_bound] = useState({});
  const [sequence_no, setsequence_no] = useState('');
  const [private_key, setprivate_key] = useState(null);
  const [selectedDays, setSelectedDays] = useState([]);
  const [selectedDate, setSelectedDate] = useState([]);
  const [formattedDates, setFormattedDates] = useState([]);
  const [selectedTime, setselectedTime] = useState([]);
  const [open, setOpen] = useState(false);
  const [showtime, setshowtime] = useState(false);
  const dropdownRef = useRef(null);
  const TimedownRef = useRef(null);
  const ref = useRef();


  const navigate = useNavigate();

  const weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const hoursArray = [
    "00:00", "01:00", "02:00", "03:00", "04:00", "05:00",
    "06:00", "07:00", "08:00", "09:00", "10:00", "11:00",
    "12:00", "13:00", "14:00", "15:00", "16:00", "17:00",
    "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"
  ];
  const countryTimeZones = {
    "India": "+05:30",
    "United States (Eastern Time)": "-05:00",
    "United States (Central Time)": "-06:00",
    "United States (Mountain Time)": "-07:00",
    "United States (Pacific Time)": "-08:00",
    "United Kingdom": "+00:00",
    "Australia (Sydney)": "+10:00",
    "Australia (Perth)": "+08:00",
    "Canada (Toronto)": "-05:00",
    "Canada (Vancouver)": "-08:00",
    "Germany": "+01:00",
    "France": "+01:00",
    "Italy": "+01:00",
    "Spain": "+01:00",
    "Russia (Moscow)": "+03:00",
    "China": "+08:00",
    "Japan": "+09:00",
    "South Korea": "+09:00",
    "Singapore": "+08:00",
    "United Arab Emirates": "+04:00",
    "Saudi Arabia": "+03:00",
    "Brazil (São Paulo)": "-03:00",
    "Argentina": "-03:00",
    "South Africa": "+02:00",
    "Nigeria": "+01:00",
    "Mexico": "-06:00",
    "New Zealand": "+12:00",
    "Pakistan": "+05:00",
    "Bangladesh": "+06:00",
    "Thailand": "+07:00",
    "Indonesia (Jakarta)": "+07:00",
    "Philippines": "+08:00",
    "Vietnam": "+07:00",
    "Turkey": "+03:00",
    "Egypt": "+02:00",
    "Israel": "+02:00"
  };
  const menus = [
    {
      name: 'Integrations',
      id
    },
    {
      name: 'Out Bound',
      id,
      submenu: [{ name: 'All In Bounds', id, int_id, type: 'Out' }
      ]
    },
    (su_admin || admin ? { name: 'Users', id } : { name: null, id })
  ];
  const getvalues = async () => {
    await axios.get(`/out_bound/Edit/${E_id}`).then((res) => {
      let response = res.data;
      setsequence_no(response.Sequence_No);
      const { Export_Details, S_Date, S_Time } = response;
      response.Export_Details = JSON.parse(Export_Details);
      response.S_Date = JSON.parse(S_Date);
      response.S_Time = JSON.parse(S_Time);
      if (response.S_Date.type === "Weekly") {
        setSelectedDays(response.S_Date.value || []);
        // console.log(response.S_Date.value);
      } else if (response.S_Date.type === "Monthly") {
        const dates = response.S_Date.value || [];
        setFormattedDates(dates);
        const strdate = dates.map(dateStr => {
          // Split dd/mm/yyyy → [dd, mm, yyyy]
          const [day, month, year] = dateStr.split('/');
          // Create Date object (month - 1 because JS months are 0-based)
          return new Date(year, month - 1, day);
        });
        // console.log(strdate);
        setSelectedDate(strdate);
      }
      if (response.S_Time.hours) {
        setselectedTime(response.S_Time?.hours)
      }
      setOut_bound(response)
      setnonetags([response.Export_Type, response.Export_Details.pass_type])

    })
      .catch((err) => {
        // toast.error("Error From Edit Out Bound Details", {
        //   autoClose: 2000, // 2 seconds
        // });
      });
  };
  const handletype = (value) => {
    setnonetags((prevData) => {
      let updatedTags = [...prevData];
      if (value === 'HTTP') {
        updatedTags = updatedTags.filter(val => val !== 'FTP' && val !== 'pass' && val !== 'key');
        updatedTags.push(value);
      } else if (value === 'FTP') {
        updatedTags = updatedTags.filter(val => val !== 'HTTP' && val !== 'pass' && val !== 'key');
        updatedTags.push(value);
      }
      else if (value === 'pass') {
        updatedTags = updatedTags.filter(val => val !== 'key');
        updatedTags.push(value);
      }
      else if (value === 'key') {
        updatedTags = updatedTags.filter(val => val !== 'pass');
        updatedTags.push(value);
      }
      // console.log(updatedTags);
      return updatedTags;
    });
  };
  const handle_folder_path = (value) => {
    const convertedPath = value.replace(/\\/g, '/');
    return convertedPath;
  };
  const handle_key = (e) => {
    setprivate_key(e.target.files[0]);
  }
  const handleinput = (id, value, additional = null) => {
    // console.log(id, value, additional);
    if (id === 'S_Date') {
      setOut_bound((preVData) => {
        return {
          ...preVData, [id]: {
            type: value,
            value: []
          }
        }
      });
    }
    else if (id === 'S_Time') {
      setOut_bound((preVData) => {
        return {
          ...preVData, [id]: {
            country: value,
            value: countryTimeZones[value]
          }
        }
      });
    } else if (id === 'Export_Type') {
      setOut_bound((preVData) => {
        return { ...preVData, [id]: value, Export_Details: {} }
      });
      setprivate_key(null)
    }
    else {
      if (additional) {
        if (id === 'Url') {
          setOut_bound((preVData) => {
            return { ...preVData, Export_Details: { [id]: value } }
          });
        } else {
          setOut_bound((preVData) => {
            if (preVData.Export_Details?.Url) {
              const { Url, ...rest } = preVData.Export_Details
              preVData.Export_Details = rest
            }
            return { ...preVData, Export_Details: { ...preVData.Export_Details, [id]: value } }
          });
        }
      } else {
        setOut_bound((preVData) => {
          return { ...preVData, [id]: value }
        });
      }
    }
  };
  const Upload_key = async (sequence_no) => {
    let formData = new FormData();
    formData.append("key", private_key);
    formData.append("filename", `${sequence_no}`);
    await axios.post(`/out_bound/upload_key`, formData).then((res) => {
      toast.success(res.data, {
        autoClose: 2000, // 2 seconds
      });
    })
      .catch((err) => {
        console.log(`error`);
      });
  };
  const Toady_Date = () => {
    const now = new Date();
    return `${now.getDate().toString().padStart(2, '0')} - ${(now.getMonth() + 1).toString().padStart(2, '0')} - ${now.getFullYear()}`;
  };

  const handlesubmit = async () => {
    const { Export_Details, S_Date, S_Time } = Out_bound;
    const datevalue = {
      ...S_Date, value: S_Date.type === 'Weekly' ? selectedDays : formattedDates
    };
    const timevalue = {
      ...S_Time, hours: selectedTime
    }
    const data = {
      ...Out_bound, Export_Details: JSON.stringify(Export_Details), S_Date: JSON.stringify(datevalue), S_Time: JSON.stringify(timevalue)
    }
    // console.log(formattedDates);
    if (private_key && Out_bound.Export_Type === 'FTP') {
      Upload_key(sequence_no);
    }
    await axios.patch(`/out_bound/values/${E_id}`, data).then((res) => {
      navigate(`/out_bound_details/${id}/${int_id}`);
    })
      .catch((err) => {
        console.log('handlesubmit api error');
      });
  };
  const get_level = () => {
    const level = Cookies.get("level");
    if (level === "Super Admin") {
      setsu_admin(true);
    }
    else if (level === 'Admin') {
      setadmin(true)
    }
  };
  const check = () => {
    console.log(nonetags);

  };
  const countryList = () => {
    return Object.keys(countryTimeZones)
  }
  // Toggle dropdown open/close
  const toggleDropdown = () => {
    setOpen(!open);
  };
  const toggleDropdowntime = () => {
    setshowtime(!showtime)
  };
  // Toggle selection of a day
  const toggleDay = (day) => {
    setSelectedDays(prev =>
      prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day]
    );
  };
  const toggletime = (time) => {
    setselectedTime(prev =>
      prev.includes(time) ? prev.filter(d => d !== time) : [...prev, time]
    );
  };
  // Close dropdown when clicking outside
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setOpen(false);
    }
    if (TimedownRef.current && !TimedownRef.current.contains(event.target)) {
      setshowtime(false);
    }
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false);
    }
  };
  const handledate = (dates) => {
    setSelectedDate(dates || []);
    // format to dd/mm/yyyy
    const formatted = (dates || []).map((date) => {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0"); // month is 0-indexed
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    });
    setFormattedDates(formatted)
  }
  // Close popup when clicking outside
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    getvalues();
    get_level();
  }, []);

  return (
    <div className='container df fdc jb ac'>
      <Navbar />
      <div className='main_box df'>
        <Menu_Items menu={menus} />
        <div className='content df fdc ac'>
          <div className='page_header df jb ac'>
            <div className='w90 df ac'>
              <MdEditSquare className='page_icon db' onClick={check} />
              <p>Edit Out Bound</p></div>
          </div>
          <div className='box '>
            <div className='create_box'>
              <div>
                <label>Export Name</label>
                <input type='search' id='Name' value={Out_bound.Name ? Out_bound.Name : ''} onChange={(e) => { handleinput(e.target.id, e.target.value) }} />
              </div>
              <div>
                <label>Export Type</label>
                <select id='Export_Type' value={Out_bound.Export_Type || ''} onChange={(e) => { handletype(e.target.value); handleinput(e.target.id, e.target.value) }} >
                  <option>Please Select</option>
                  <option value={'HTTP'}>HTTP</option>
                  <option value={'FTP'}>FTP</option>
                </select>
              </div>
              <div id={`${nonetags.includes(`HTTP`) ? 'block' : 'none'}`}>
                <label>End Point URL</label>
                <input type='search' id='Url' value={Out_bound.Export_Details?.Url || ''} onChange={(e) => { handleinput(e.target.id, e.target.value, 'HTTP') }} />
              </div>
              <div id={`${nonetags.includes(`FTP`) ? 'block' : 'none'}`}>
                <label>Host Id</label>
                <input type='search' id='host' value={Out_bound.Export_Details?.host || ''} onChange={(e) => { handleinput(e.target.id, e.target.value, 'FTP') }} />
              </div>
              <div id={`${nonetags.includes(`FTP`) ? 'block' : 'none'}`}>
                <label>User Id</label>
                <input type='search' id='user' value={Out_bound.Export_Details?.user || ''} onChange={(e) => { handleinput(e.target.id, e.target.value, 'FTP') }} />
              </div>
              <div id={`${nonetags.includes(`FTP`) ? 'block' : 'none'}`}>
                <label>Password Type</label>
                <select id='pass_type' value={Out_bound.Export_Details?.pass_type || ''} onChange={(e) => { handletype(e.target.value); handleinput(e.target.id, e.target.value, 'FTP') }} >
                  <option>Please Select</option>
                  <option value={'pass'}>Password</option>
                  <option value={'key'}>Private Key</option>
                </select>
              </div>
              <div id={`${nonetags.includes(`pass`) ? 'block' : 'none'}`}>
                <label>Password</label>
                <input type='search' value={Out_bound.Export_Details?.pass || ''} id='pass' onChange={(e) => { handleinput(e.target.id, e.target.value, 'FTP') }} />
              </div>
              <div id={`${nonetags.includes(`keykey`) ? 'block' : 'none'}`}>
                <label>Select Private key</label>
                <input id="key" type="file" required accept='.pem' onChange={(e) => { handle_key(e); handleinput('pass', `${sequence_no}.pem`, 'FTP') }} />
              </div>
              <div id={`${nonetags.includes(`FTP`) ? 'block' : 'none'}`}>
                <label>Directory Folder Path</label>
                <input type='search' id='Path' value={Out_bound.Path ? Out_bound.Path : ''} onChange={(e) => { handleinput(e.target.id, handle_folder_path(e.target.value)) }} />
              </div>
              <div>
                <label>Export File Type</label>
                <select id='File_Type' value={Out_bound.File_Type ? Out_bound.File_Type : ''} onChange={(e) => { handleinput(e.target.id, e.target.value) }} >
                  <option>Please Select</option>
                  <option value={'csv'}>CSV</option>
                  <option value={'json'}>JSON</option>
                </select>
              </div>
              <div>
                <label>Schedule Date</label>
                <select id='S_Date' value={Out_bound.S_Date?.type} onChange={(e) => { handleinput(e.target.id, e.target.value); setSelectedDays([]); setSelectedDate([]); setFormattedDates([]) }}>
                  <option value={''}>Please Select</option>
                  <option value={'Daily'}>Daily</option>
                  <option value={'Weekly'}>Weekly</option>
                  <option value={'Monthly'}>Monthly</option>
                </select>
              </div>
              {
                Out_bound.S_Date?.type === 'Weekly' && <div ref={dropdownRef} className='pr'>
                  <label>Select Day</label>
                  <input readOnly onClick={toggleDropdown} className='b1' type='search' value={selectedDays.length > 0 ? selectedDays.join(',') : 'Select day(s)'} />
                  <FaAngleDown className='pa ' onClick={toggleDropdown} style={{ right: '0px', bottom: '0.7vh', width: '8%', height: '1.5vh' }} />
                  {open && (
                    <div className='b0111 white' style={{ zIndex: 1 }}>
                      {weekDays.map((day, i) => (
                        <label key={i} className='df ac padleft gap'>
                          <input
                            type="checkbox"
                            checked={selectedDays.includes(day)}
                            onChange={() => toggleDay(day)}
                          />
                          {day}
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              }
              {
                Out_bound.S_Date?.type === 'Monthly' && <div ref={ref}>
                  <label>select Date</label>
                  <div className="calendar-wrapper" >
                    <input
                      type='search'
                      readOnly
                      onClick={() => setOpen(!open)}
                      value={
                        selectedDate.length > 0
                          ? selectedDate.map(d => d.toLocaleDateString()).join(",  ")
                          : "Select date(s)"
                      }
                    />

                    {open && (
                      <div className="calendar-popup">
                        <DayPicker
                          mode="multiple"       // 👈 for multiple selection (use "single" for one date)
                          selected={selectedDate}
                          onSelect={handledate}
                        />
                      </div>
                    )}
                  </div>
                </div>
              }
              <div className='pr' ref={TimedownRef}>
                <label>Schedule Time</label>
                <input readOnly className='b1' type='search' onClick={toggleDropdowntime} value={selectedTime.length > 0 ? selectedTime.join(',') : 'Select Time'} />
                <FaAngleDown className='pa ' onClick={toggleDropdowntime} style={{ right: '0px', bottom: '0.7vh', width: '8%', height: '1.5vh' }} />
                {showtime && (
                  <div className='b0111 h20 of_a white' style={{ zIndex: 1 }}>
                    {hoursArray.map((time, i) => (
                      <label key={i} className='df ac padleft gap'>
                        <input
                          type="checkbox"
                          checked={selectedTime.includes(time)}
                          onChange={() => toggletime(time)}
                        />
                        {time}
                      </label>
                    ))}
                  </div>
                )}
              </div>
              <div>
                <label>Select Country</label>
                <select id='S_Time' value={Out_bound.S_Time?.country || ''} onChange={(e) => { handleinput(e.target.id, e.target.value) }}>
                  <option>Select Time Zone</option>
                  {
                    countryList().map((country, i) => (
                      <option value={country} key={i}>{country}</option>
                    ))
                  }
                </select>
              </div>
            </div>
            <div className='w100 h10 df jc ac'>
              <button className='btn green' onClick={handlesubmit}>Submit</button>
            </div>
          </div>
        </div>
      </div>
      {/* <div className='h_btn df jc ac'>
        <p className='df jc ac'>Edit Out Bound</p>
      </div> */}

      {/* <Back location={`/out_bound_details/${id}/${int_id}`} /> */}
    </div >
  )
}

export default Edit_Export_Details;